<canvas #paintCanvas oncontextmenu="return false;" style="height: auto; max-height:50vh;max-width: 58vw;width: auto"></canvas>
